<template>
  <div class="home-container" :class="{ 'home-container--learn': learn }">
    <div style="width: 15%" :class="learn ? 'hide' : ''">
      <div class="chat-list" >
        <div class="title">MYTutor</div>
        <el-input class="input" :placeholder="$t('chat.placeholder')" v-model="keywords" prefix-icon="el-icon-search"></el-input>
        <div class="chat-p-list">
          <div v-for="(item, index) in recordList" :key="index" style="padding: 0 12px">
            <div v-if="filteredData(item.key).length > 0">
              <div class="data" @click="item.isShow = !item.isShow"><img :src="item.img" alt=""> {{ $t(item.label) }}</div>
              <div v-if="item.isShow">
                <div
                  v-for="chat in filteredData(item)"
                  :key="chat.id"
                  class="chat-item"
                  @click="getHistoricalNews(chat)"
                >
                  <span>{{ chat.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="user-info">
          <el-dropdown v-if="userInfo" @command="handleCommand" trigger="click" placement="top-start">
            <span class="el-dropdown-link">
              <div class="avatar avatar-name">
                {{ userInfo.username.charAt(0) }}
              </div>
              {{$t('chat.info')}}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="userAccount"><span style="padding: 0 12px">{{ userInfo.userAccount }}</span></el-dropdown-item>
              <el-dropdown-item command="profile"><img :src="require('@/assets/profile.png')" alt=""/>{{$t('chat.profile')}}</el-dropdown-item>
              <el-dropdown-item command="logout"><img :src="require('@/assets/logout.png')" alt=""/>{{$t('chat.signOut')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span v-else @click="goToLogin" style="cursor: pointer">{{$t('chat.signIn')}}</span>
        </div>
      </div>
    </div>
    <div style="width: 85%; display: flex; justify-content: center" :style="learn ? 'width: 100%' : ''">
      <div class="chat-container" :class="learn ? 'chat-hide' : ''">
        <div class="topic-header" :style="learn ? 'display:none' : ''">
          <h2>{{$t('chat.topic')}}: {{ topic }}</h2>
        </div>
        <div class="chat-content" ref="chatContent">
          <LearningWelcomeCard
            v-if="learn"
            :context="learningContext"
            :loading="learningContextLoading"
            :error="learningContextError"
            :student-name="studentName"
          />
          <div
            v-for="(message, index) in displayMessages"
            :key="index"
            :class="['message', message.role === 'user' ? 'user' : 'bot']"
          >
            <div v-if="typeof message.content === 'string'">
              <div class="avatar avatar-name" v-if="message.role === 'user'">
                {{ userInfo.username.charAt(0) }}
              </div>
              <div
                class="avatar"
                :class="['bot', { breathing: currentMessageIndex === index }]"
                v-else
              >
                <img :src="require('@/assets/teacher.png')" alt="teacher" />
              </div>
            </div>
            <div v-else class="avatar" style="background: transparent"></div>
            <div
              v-if="typeof message.content === 'string'"
              :class="['message-content', message.role !== 'user' ? 'copy' : '']"
            >
              <span v-html="formatMessage(message.content)" />
              <i v-if="message.role !== 'user' && message.content" class="el-icon-copy-document" @click="copyToClipboard(message.content)"/>
            </div>
            <div v-else style="max-width: 50%">
              <img
                :src="message.content[0].image_url.url"
                alt="image"
                style="max-width: 100%"
              />
            </div>
          </div>
        </div>
        <div class="section">
          <div v-if="imgUrl">
            <img :src="imgUrl" alt="image" />
            <i @click="imgUrl = ''" class="el-icon-error close"></i>
          </div>
          <div
            v-if="learn"
            :class="['chat-quota-row', { 'chat-quota-row--empty': chatQuotaExhausted }]"
          >
            <span class="chat-quota-remaining">
              <i class="el-icon-magic-stick" aria-hidden="true" />
              {{ $t('chat.aiMessagesLeft', { remaining: chatQuotaRemaining }) }}
            </span>
            <small v-if="chatQuota">
              {{ $t('chat.aiQuotaResets', { date: formatQuotaResetDate(chatQuota.nextResetAt) }) }}
            </small>
          </div>
          <div class="input-section">
            <el-input
              v-model="userInput"
              type="textarea"
              rows="{1}"
              :placeholder="$t('chat.followUp')"
              :disabled="loading || chatQuotaExhausted"
              resize="none"
              @keyup.enter.native="sendMessage"
            >
            </el-input>
            <div class="send-button">
              <el-upload
                v-if="!imgUrl"
                style="font-size: 20px;cursor: pointer;width: 32px;height: 100%;display: flex;align-items: center;justify-content: center;}"
                :show-file-list="false"
                :limit="1"
                :http-request="handleUpload"
                :before-upload="beforeUpload"
                accept="image/*"
                action=""
                :disabled="loading || chatQuotaExhausted"
              >
                <i
                  class="el-icon-picture-outline-round"
                  style="cursor: pointer"
                />
              </el-upload>
              <el-button
                type="primary"
                @click="sendMessage"
                :loading="loading"
                :disabled="loading || chatQuotaExhausted"
                class="send-message"
              >
                <i class="el-icon-s-promotion" v-if="!loading" />
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="learning-history">
      <div v-if="learn && learningHistoryVisible" class="learning-history-layer">
        <button
          type="button"
          class="learning-history-scrim"
          :aria-label="$t('chat.history.button')"
          @click="closeLearningHistory"
        />
        <aside class="learning-history-drawer" :aria-label="$t('chat.history.title')">
          <header class="learning-history-header">
            <div>
              <h3>{{ $t('chat.history.title') }}</h3>
              <p>{{ learningKnowledgePointName || $t('chat.history.subtitle') }}</p>
            </div>
            <button type="button" class="learning-history-close" :aria-label="$t('chat.history.button')" @click="closeLearningHistory">
              <i class="el-icon-close" aria-hidden="true" />
            </button>
          </header>

          <el-input
            v-model="historySearch"
            class="learning-history-search"
            :placeholder="$t('chat.history.search')"
            prefix-icon="el-icon-search"
            clearable
          />

          <div class="learning-history-list">
            <div v-if="learningHistoryLoading" class="learning-history-state">
              <i class="el-icon-loading" aria-hidden="true" />
            </div>
            <div v-else-if="learningHistoryError" class="learning-history-state learning-history-state--error">
              <span>{{ $t('chat.history.loadFailed') }}</span>
              <button type="button" @click="loadLearningHistory(true)">{{ $t('chat.history.retry') }}</button>
            </div>
            <template v-else-if="learningHistoryGroups.length">
              <section v-for="group in learningHistoryGroups" :key="group.key" class="learning-history-group">
                <h4>{{ group.label }}</h4>
                <button
                  v-for="chat in group.items"
                  :key="chat.conversationId"
                  type="button"
                  class="learning-history-item"
                  :class="{ 'learning-history-item--active': chat.conversationId === selectedConversationId }"
                  :disabled="historySelectionLoadingId === chat.conversationId"
                  @click="selectLearningHistory(chat)"
                >
                  <span class="learning-history-copy">
                    <strong>{{ chat.title || $t('chat.history.newChat') }}</strong>
                    <small>{{ $t('chat.history.continue') }}</small>
                  </span>
                  <span class="learning-history-time">{{ formatHistoryTimestamp(chat.createTime) }}</span>
                </button>
              </section>
            </template>
            <div v-else class="learning-history-state">
              <span>{{ $t('chat.history.empty') }}</span>
            </div>
          </div>

          <button type="button" class="learning-history-new" @click="startNewLearningChat">
            <i class="el-icon-plus" aria-hidden="true" />
            {{ $t('chat.history.startNew') }}
          </button>
        </aside>
      </div>
    </transition>
    <el-dialog
      title="Profile"
      :visible.sync="profileVisible"
      width="30%"
      @close="close"
    >
      <el-form :model="formData" :rules="rules" ref="profileForm" label-width="160px" style="width: 100%">
        <el-row :gutter="16" style="margin: 0 !important;">
          <el-form-item label="Username" prop="userAccount">
            <el-input v-model="formData.userAccount" disabled/>
          </el-form-item>
          <el-form-item label="Prefered Name" prop="username">
            <el-input v-model="formData.username" />
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input v-model="formData.email" disabled/>
          </el-form-item>
          <el-form-item label="Gender" prop="sex">
            <el-select v-model="formData.sex" style="width: 100%">
              <el-option label="Male" value="1" />
              <el-option label="Female" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="Age" prop="age" v-if="userInfo && userInfo.role !== 'P'">
            <el-input-number v-model="formData.age" :min="1" :max="100" style="width: 100%" />
          </el-form-item>
          <el-form-item label="Nationality" prop="country">
            <el-input v-model="formData.country" />
          </el-form-item>
          <el-form-item label="Grade" prop="grade" v-if="userInfo && userInfo.role !== 'P'">
            <el-select v-model="formData.grade" style="width: 100%" placeholder="please select">
              <el-option :label="$t('register.gradeOne')" value="1" />
              <el-option :label="$t('register.gradeTwo')" value="2" />
              <el-option :label="$t('register.gradeThree')" value="3" />
              <el-option :label="$t('register.gradeFour')" value="4" />
              <el-option :label="$t('register.gradeFive')" value="5" />
              <el-option :label="$t('register.gradeSix')" value="6" />
              <el-option :label="$t('register.gradeSeven')" value="7" />
              <el-option :label="$t('register.gradeEight')" value="8" />
              <el-option :label="$t('register.gradeNine')" value="9" />
              <el-option :label="$t('register.gradeTen')" value="10" />
              <el-option :label="$t('register.gradeEleven')" value="11" />
              <el-option :label="$t('register.gradeTwelve')" value="12" />
            </el-select>
          </el-form-item>
          <el-form-item label="Phone" prop="parent.tel">
            <el-input v-model="formData.tel" disabled/>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" size="small">cancel</el-button>
        <el-button type="primary" @click="confirm" size="small">confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  chat,
  context,
  getConversationList,
  getConversationDetail,
  getParentConversationList,
  upload,
  findById, edit
} from '@/api/user'
import { marked } from 'marked'
import 'katex/dist/katex.min.css'
import katex from 'katex'
import { mapState } from 'vuex'
import LearningWelcomeCard from '@/components/LearningWelcomeCard.vue'
import { getChatQuota } from '@/api/aiQuota'

export default {
  name: 'Chat',
  components: { LearningWelcomeCard },
  props: {
    learn: {
      type: Boolean,
      default: false
    },
    learningContext: {
      type: Object,
      default: null
    },
    learningContextLoading: {
      type: Boolean,
      default: false
    },
    learningContextError: {
      type: Boolean,
      default: false
    },
    studentName: {
      type: String,
      default: ''
    },
    knowledgePointId: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      topic: '',
      userInput: '',
      loading: false,
      messages: [],
      contextId: '',
      contextPromise: null,
      currentMessageIndex: -1,
      chatQuota: null,
      chatList: {
        chatMessages: []
      },
      imgUrl: '',
      recordList: [
        { key: 'today', isShow: true, label: 'today', img: require('@/assets/today.png') },
        { key: 'yesterday', isShow: true, label: 'yesterday', img: require('@/assets/yesterday.png') },
        { key: 'last7days', isShow: true, label: 'last7days', img: require('@/assets/last7days.png') },
        { key: 'earlier', isShow: true, label: 'earlier', img: require('@/assets/earlier.png') }
      ],
      keywords: '',
      learningHistoryVisible: false,
      learningHistoryLoading: false,
      learningHistoryError: false,
      historySearch: '',
      historySelectionLoadingId: '',
      selectedConversationId: '',
      profileVisible: false,
      formData: {
        userAccount: '',
        username: '',
        sex: '',
        password: '',
        rePassword: '',
        tel: '',
        country: '',
        email: '',
        grade: '',
        age: ''
      },
      rules: {
        username: [
          { required: true, message: this.$t('validation.enterUsername'), trigger: 'blur' }
        ],
        sex: [
          { required: true, message: this.$t('validation.selectGender'), trigger: 'change' }
        ],
        country: [
          { required: true, message: this.$t('validation.enterNationality'), trigger: 'blur' }
        ],
        grade: [
          { required: true, message: this.$t('validation.enterGrade'), trigger: 'blur' }
        ],
        age: [
          { required: true, message: this.$t('validation.enterAge'), trigger: 'blur' },
          { type: 'number', message: this.$t('validation.ageMustBeNumber'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    displayMessages () {
      return this.messages.filter((msg) => msg.role !== 'system')
    },
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    }),
    currentUserId () {
      return this.userInfo && this.userInfo.id
    },
    chatQuotaRemaining () {
      if (!this.chatQuota) return 0
      return Math.max(Number(this.chatQuota.remaining) || 0, 0)
    },
    chatQuotaExhausted () {
      return this.learn && this.chatQuotaRemaining <= 0
    },
    learningKnowledgePointName () {
      const query = this.$route && this.$route.query ? this.$route.query : {}
      return String(query.pointName || query.knowledgePointName || '')
    },
    learningHistoryGroups () {
      const query = this.historySearch.trim().toLowerCase()
      const buckets = { today: [], yesterday: [], earlier: [] }
      const messages = Array.isArray(this.chatList.chatMessages)
        ? this.chatList.chatMessages
        : []

      messages.forEach((chat) => {
        const title = String(chat.title || '')
        if (query && !title.toLowerCase().includes(query)) return
        buckets[this.historyGroupKey(chat.createTime)].push(chat)
      })

      return [
        { key: 'today', label: this.$t('chat.history.today'), items: buckets.today },
        { key: 'yesterday', label: this.$t('chat.history.yesterday'), items: buckets.yesterday },
        { key: 'earlier', label: this.$t('chat.history.earlier'), items: buckets.earlier }
      ].filter((group) => group.items.length > 0)
    },
    filteredData () {
      return (filterType) => {
        const now = new Date() // 当前时间
        const todayStart = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate()
        ) // 今天开始时间 00:00:00
        const yesterdayStart = new Date(todayStart)
        yesterdayStart.setDate(yesterdayStart.getDate() - 1) // 昨天开始时间 00:00:00

        const sevenDaysAgoStart = new Date(todayStart)
        sevenDaysAgoStart.setDate(sevenDaysAgoStart.getDate() - 7) // 7天前的开始时间 00:00:00

        const list = this.chatList.chatMessages.filter((item) => {
          return item.title.toLowerCase().includes(this.keywords.toLowerCase())
        })
        return list.filter((item) => {
          const itemDate = new Date(item.createTime)
          const itemDateOnly = new Date(
            itemDate.getFullYear(),
            itemDate.getMonth(),
            itemDate.getDate()
          )

          switch (filterType) {
            case 'today':
              return itemDateOnly.getTime() === todayStart.getTime()
            case 'yesterday':
              return itemDateOnly.getTime() === yesterdayStart.getTime()
            case 'last7days':
              // 过滤出七天前至昨天的数据（不包括今天和昨天）
              return (
                itemDateOnly < yesterdayStart &&
                itemDateOnly >= sevenDaysAgoStart
              )
            case 'earlier':
              // 更早之前的数据（早于7天前）
              return itemDateOnly < sevenDaysAgoStart
            default:
              return true // 返回全部
          }
        })
      }
    }
  },
  watch: {
    knowledgePointId (nextValue, previousValue) {
      if (!this.learn || String(nextValue) === String(previousValue)) return
      this.resetLearningConversation()
      this.chatList.chatMessages = []
      this.loadLearningHistory(true)
      this.loadChatQuota()
    },
    currentUserId (nextValue, previousValue) {
      if (!this.learn || !nextValue || String(nextValue) === String(previousValue)) return
      this.loadLearningHistory(true)
      this.loadChatQuota()
    }
  },
  created () {
    // 从路由参数获取topic
    this.topic = this.$route.query.topic || 'Unknown Topic'
    this.childName = this.$route.query.childName || ''
  },
  mounted () {
    // 添加系统消息
    if (!this.learn) {
      this.getContext()
      this.getUserList()
    } else {
      this.loadLearningHistory(true)
      this.loadChatQuota()
    }
  },
  methods: {
    async loadChatQuota () {
      if (!this.learn || !this.currentUserId) {
        this.chatQuota = null
        return
      }
      try {
        const res = await getChatQuota()
        this.chatQuota = res.code === 200 ? res.data : null
      } catch (error) {
        this.chatQuota = null
      }
    },
    formatQuotaResetDate (value) {
      if (!value) return '-'
      return new Date(value).toLocaleDateString(
        this.$i18n.locale === 'fr' ? 'fr-CA' : 'en-CA',
        { month: 'short', day: 'numeric' }
      )
    },
    chatRequestId () {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID()
      }
      return `chat-${Date.now()}-${Math.random().toString(16).slice(2)}`
    },
    isChatQuotaError (error) {
      return error?.response?.status === 429 || error?.response?.data?.code === 'AI_CHAT_QUOTA_EXHAUSTED'
    },
    openLearningHistory () {
      this.learningHistoryVisible = true
      this.loadLearningHistory()
    },
    closeLearningHistory () {
      this.learningHistoryVisible = false
      this.historySearch = ''
    },
    async loadLearningHistory (force = false) {
      if (!this.learn || !this.currentUserId || !this.boundKnowledgePointId()) return
      if (this.learningHistoryLoading) return
      if (!force && this.chatList.chatMessages.length > 0) return

      this.learningHistoryLoading = true
      this.learningHistoryError = false
      try {
        const res = await getConversationList(this.currentUserId, this.boundKnowledgePointId())
        if (res.code !== 200) throw new Error('Failed to load conversation history')
        this.chatList.chatMessages = res.data || []
      } catch (error) {
        this.learningHistoryError = true
      } finally {
        this.learningHistoryLoading = false
      }
    },
    resetLearningConversation () {
      this.contextId = ''
      this.contextPromise = null
      this.selectedConversationId = ''
      this.messages = []
      this.userInput = ''
      this.imgUrl = ''
    },
    startNewLearningChat () {
      if (this.loading) return
      this.resetLearningConversation()
      this.closeLearningHistory()
      this.$nextTick(() => this.scrollToBottom())
    },
    async selectLearningHistory (chat) {
      if (!chat || !chat.conversationId || this.historySelectionLoadingId) return
      this.historySelectionLoadingId = chat.conversationId
      try {
        await this.getHistoricalNews(chat)
        this.closeLearningHistory()
        this.$nextTick(() => this.scrollToBottom())
      } catch (error) {
        this.$message.error(this.$t('chat.history.loadFailed'))
      } finally {
        this.historySelectionLoadingId = ''
      }
    },
    historyGroupKey (value) {
      const itemDate = new Date(value)
      if (Number.isNaN(itemDate.getTime())) return 'earlier'
      const today = new Date()
      const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      const yesterdayStart = new Date(todayStart)
      yesterdayStart.setDate(yesterdayStart.getDate() - 1)
      const itemStart = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate())
      if (itemStart.getTime() === todayStart.getTime()) return 'today'
      if (itemStart.getTime() === yesterdayStart.getTime()) return 'yesterday'
      return 'earlier'
    },
    formatHistoryTimestamp (value) {
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return ''
      const locale = this.$i18n.locale === 'fr' ? 'fr-CA' : 'en-CA'
      if (this.historyGroupKey(value) === 'today' || this.historyGroupKey(value) === 'yesterday') {
        return date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
      }
      return date.toLocaleDateString(locale, { month: 'short', day: 'numeric' })
    },
    getUserList () {
      if (this.userInfo.role === 'P') {
        getParentConversationList(this.userInfo.id).then((res) => {
          if (res.code !== 200) {
            return false
          }
          console.log('%c FXY', 'color: #46cef9;font-size:37px', 11111111)
          if (this.childName) {
            this.chatList = res.data[this.childName] || []
            this.getHistoricalNews(this.chatList.chatMessages[0])
          } else {
            this.chatList = res.data.yours || []
          }
        })
      } else {
        getConversationList(this.userInfo.id).then((res) => {
          if (res.code !== 200) {
            return false
          }
          this.chatList.chatMessages = res.data || []
        })
      }
    },
    getContext () {
      this.ensureContext(this.topic).then(
        () => {
          // 如果有初始话题，自动发送请求
          if (this.topic && this.topic !== 'Unknown Topic') {
            this.autoSendFirstMessage()
          }
        },
        () => {
          // 未登录，跳转到登录页面，并携带重定向信息
          this.$router.push({
            path: '/login',
            query: {
              redirect: '/chat',
              topic: this.topic
            }
          })
        }
      )
    },
    ensureContext (question) {
      if (this.contextId) return Promise.resolve(this.contextId)
      if (this.contextPromise) return this.contextPromise
      if (!this.userInfo?.id) return Promise.reject(new Error('Missing user information'))

      this.contextPromise = context({
        user_id: this.userInfo.id,
        knowledge_point_id: this.boundKnowledgePointId(),
        question
      }).then((res) => {
        if (res.code !== 200 || !res.data) {
          throw new Error('Failed to create conversation')
        }
        this.contextId = res.data
        this.selectedConversationId = this.contextId
        if (this.learn) this.loadLearningHistory(true)
        return this.contextId
      }).finally(() => {
        this.contextPromise = null
      })

      return this.contextPromise
    },
    async autoSendFirstMessage () {
      try {
        this.loading = true
        // 添加用户的第一条消息
        const userMessage = {
          role: 'user',
          content: this.topic
        }
        this.messages.push(userMessage)

        // 添加一个空的助手消息用于流式更新
        const assistantMessage = {
          role: 'assistant',
          content: ''
        }
        this.messages.push(assistantMessage)
        // 计算在displayMessages中的索引
        this.currentMessageIndex = this.displayMessages.length - 1
        const params = {
          stream: true,
          stream_options: {
            include_usage: true
          },
          messages: this.processMessages(this.messages.slice(0, -1)), // 不包含刚添加的空助手消息
          conversation_id: this.contextId,
          user_id: this.userInfo.id,
          knowledge_point_id: this.boundKnowledgePointId()
        }
        console.log('%c FXY', 'color: #46cef9;font-size:37px', params)
        // 调用聊天接口
        await chat(params, (chunk) => {
          // 更新助手消息内容
          assistantMessage.content += chunk
          console.log(
            '%c FXY1',
            'color: #46cef9;font-size:37px',
            assistantMessage.content
          )
          // 自动滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom()
          })
        })
      } catch (error) {
        console.error('聊天错误:', error)
        this.$message.error(this.$t('chat.msg.initFailed'))
        // 移除空的助手消息
        this.messages.pop()
      } finally {
        this.loading = false
        this.currentMessageIndex = -1
      }
    },
    async sendMessage () {
      const pendingInput = this.userInput.trim()
      if (!pendingInput || this.loading) return
      if (this.chatQuotaExhausted) {
        this.$message.warning(this.$t('chat.msg.quotaExhausted'))
        return
      }
      let assistantMessage = null

      try {
        this.loading = true
        await this.ensureContext(pendingInput)

        let isImg = false
        if (this.imgUrl) {
          isImg = true
          const imageMsg = {
            role: 'user',
            content: [
              {
                type: 'image_url',
                image_url: { url: this.imgUrl }
              }
            ]
          }
          this.messages.push(imageMsg)
          this.imgUrl = ''
        }

        const userMessage = {
          role: 'user',
          content: pendingInput
        }
        this.messages.push(userMessage)
        this.userInput = ''
        this.$nextTick(() => {
          this.scrollToBottom()
        })

        // 添加一个空的助手消息用于流式更新
        assistantMessage = {
          role: 'assistant',
          content: ''
        }
        this.messages.push(assistantMessage)
        // 计算在displayMessages中的索引
        this.currentMessageIndex = this.displayMessages.length - 1
        const params = {
          stream: true,
          stream_options: {
            include_usage: true
          },
          messages: this.messages.slice(isImg ? -3 : -2, -1), // 不包含刚添加的空助手消息
          conversation_id: this.contextId,
          user_id: this.userInfo.id,
          knowledge_point_id: this.boundKnowledgePointId()
        }
        // 调用聊天接口
        await chat(params, (chunk) => {
          // 更新助手消息内容
          assistantMessage.content += chunk
          console.log(
            '%c FXY2',
            'color: #46cef9;font-size:37px',
            assistantMessage.content
          )
          // 自动滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom()
          })
        }, this.learn
          ? {
            suppressGlobalError: true,
            headers: { 'Idempotency-Key': this.chatRequestId() }
          }
          : {})
        if (this.learn) await this.loadChatQuota()
      } catch (error) {
        if (this.isChatQuotaError(error)) {
          await this.loadChatQuota()
          this.$message.warning(this.$t('chat.msg.quotaExhausted'))
        } else {
          this.$message.error(this.$t('chat.msg.sendFailed'))
        }
        if (assistantMessage && this.messages[this.messages.length - 1] === assistantMessage) {
          this.messages.pop()
        }
      } finally {
        this.loading = false
        this.currentMessageIndex = -1
      }
    },
    boundKnowledgePointId () {
      if (!this.learn) return undefined
      const knowledgePointId = Number(this.knowledgePointId)
      return Number.isInteger(knowledgePointId) && knowledgePointId > 0
        ? knowledgePointId
        : undefined
    },
    formatMessage (content) {
      if (!content) return ''
      let text = content

      // 处理行内公式（同时支持$...$和\(...\)格式）
      const processInlineFormula = (formula) => {
        try {
          // 只做最基本的清理
          formula = formula.trim()

          return katex.renderToString(formula, {
            displayMode: false,
            throwOnError: false,
            strict: false
          })
        } catch (error) {
          console.error('KaTeX渲染错误:', error)
          console.error('公式内容:', formula)
          return formula
        }
      }

      // 处理$...$格式
      text = text.replace(/\$(.*?)\$/g, (_, formula) =>
        processInlineFormula(formula)
      )
      // 处理\(...\)格式
      text = text.replace(/\\\((.*?)\\\)/g, (_, formula) =>
        processInlineFormula(formula)
      )

      // 处理块级公式
      text = text.replace(/\\\[(.*?)\\\]/gs, (_, formula) => {
        try {
          formula = formula.trim()

          return katex.renderToString(formula, {
            displayMode: true,
            throwOnError: false,
            strict: false
          })
        } catch (error) {
          console.error('KaTeX渲染错误:', error)
          console.error('公式内容:', formula)
          return formula
        }
      })

      return marked(text)
    },
    scrollToBottom () {
      const chatContent = this.$refs.chatContent
      if (chatContent) {
        chatContent.scrollTop = chatContent.scrollHeight
      }
    },
    /**
     * 处理消息数组
     * @param {Array} messages - 原始消息数组
     * @returns {Array} 处理后的消息数组
     */
    processMessages (messages) {
      // 过滤掉 assistant 消息
      const filteredMessages = messages.filter(
        (msg) => msg.role !== 'assistant'
      )

      // 合并 user 消息
      const userMessages = filteredMessages.filter(
        (msg) => msg.role === 'user'
      )
      const otherMessages = filteredMessages.filter(
        (msg) => msg.role !== 'user'
      )

      if (userMessages.length > 0) {
        const mergedUserMessage = {
          role: 'user',
          content: userMessages.map((msg) => msg.content).join('，')
        }
        return [...otherMessages, mergedUserMessage]
      }

      return filteredMessages
    },
    getHistoricalNews (chat) {
      this.topic = chat.title
      this.contextId = chat.conversationId
      this.selectedConversationId = chat.conversationId
      return getConversationDetail(chat.conversationId).then((res) => {
        if (res.code !== 200) throw new Error('Failed to load conversation')
        this.messages = res.data
          .map((item) => {
            // 处理流式数据
            let content = item.context

            // 如果是流式数据格式，需要解析
            if (typeof content === 'string' && content.includes('data:')) {
              content = this.parseStreamData(content)
            }

            return {
              role: item.type === 'q' ? 'user' : 'assistant',
              content: content
            }
          })
          .filter((item) => {
            // 增加过滤步骤
            // 当content是字符串且包含'image_url'时过滤掉这条消息
            return (
              typeof item.content !== 'string' ||
              !item.content.includes('image_url')
            )
          })
      })
    },

    /**
     * 解析流式数据
     * @param {string} streamData - 流式数据字符串
     * @returns {string} 解析后的内容
     */
    parseStreamData (streamData) {
      try {
        // 匹配所有 data: 后面跟 { ... } 的 JSON 块
        const regex = /data:({.*?})(?=data:|$)/gs
        let match
        let fullContent = ''

        while ((match = regex.exec(streamData)) !== null) {
          const jsonStr = match[1]
          try {
            const data = JSON.parse(jsonStr)
            if (data.choices && data.choices.length > 0) {
              const choice = data.choices[0]
              if (choice.delta && choice.delta.content) {
                fullContent += choice.delta.content
              }
            }
          } catch (e) {
            // 跳过无法解析的块
            continue
          }
        }

        return fullContent || streamData
      } catch (error) {
        console.error('解析流式数据失败:', error)
        return streamData
      }
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error(this.$t('chat.msg.uploadFailed'))
      }
      return isImage
    },
    async handleUpload ({ file }) {
      if (this.loading) return
      const formData = new FormData()
      formData.append('file', file)
      try {
        this.loading = true
        const res = await upload(formData)
        if (res.code !== 200) {
          this.$message.error(this.$t('chat.msg.uploadFailed'))
          return
        }
        this.imgUrl = res.data
      } catch (error) {
        this.$message.error(this.$t('chat.msg.sendFailed'))
      } finally {
        this.loading = false
      }
    },
    /**
     * @description 处理下拉菜单命令
     */
    handleCommand (command) {
      if (command === 'logout') {
        this.logout()
      }
      if (command === 'profile') {
        const params = {
          id: this.userInfo.id,
          role: this.userInfo.role
        }
        findById(params).then((res) => {
          if (res.code !== 200) {
            return false
          }
          this.profileVisible = true
          this.formData = res.data
        })
      }
    },
    close () {
      this.profileVisible = false
      this.formData = {
        userAccount: '',
        username: '',
        sex: '',
        password: '',
        rePassword: '',
        tel: '',
        country: '',
        email: '',
        grade: '',
        age: ''
      }
    },
    confirm () {
      this.$refs.profileForm.validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.formData))
          params.id = this.userInfo.id
          params.role = this.userInfo.role
          edit(params).then((res) => {
            if (res.code !== 200) {
              return false
            }
            this.$message.success('Profile updated successfully')
            this.close()
          })
        }
      })
    },
    /**
     * @description 退出登录
     */
    logout () {
      this.$store.dispatch('user/logout')
      this.$message.success('Login successfully logged out')
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    /**
     * @description 跳转到登录页面
     */
    goToLogin () {
      this.$router.push('/login')
    },
    copyToClipboard (value) {
      const val = this.parseStreamData(value)
      const aux = document.createElement('input')
      aux.value = val
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$message.success('copy successfully')
    }
  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  justify-content: center;
  max-height: 100%;
  height: 100%;
  .hide{
    display: none;
  }
}

.home-container--learn {
  position: relative;
  overflow: hidden;
}

.learning-history-layer {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  justify-content: flex-end;
}

.learning-history-scrim {
  position: absolute;
  inset: 0;
  width: 100%;
  padding: 0;
  border: 0;
  background: rgba(30, 24, 54, 0.34);
  cursor: pointer;
}

.learning-history-drawer {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 70%;
  min-width: 390px;
  max-width: 520px;
  height: 100%;
  padding: 20px 18px 18px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 20px 0 0 20px;
  box-shadow: -12px 0 32px rgba(35, 24, 68, 0.2);
}

.learning-history-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.learning-history-header h3 {
  margin: 0;
  color: #241b3b;
  font-size: 20px;
  line-height: 1.25;
}

.learning-history-header p {
  margin: 4px 0 0;
  color: #776b8e;
  font-size: 13px;
  line-height: 1.4;
}

.learning-history-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  color: #6f6485;
  background: transparent;
  cursor: pointer;
}

.learning-history-close:hover,
.learning-history-close:focus-visible {
  color: #5b21b6;
  background: #f5f3ff;
}

.learning-history-search {
  margin-top: 18px;
}

.learning-history-search :deep(.el-input__inner) {
  height: 40px;
  border-color: #ddd7e8;
  border-radius: 10px;
  color: #302742;
}

.learning-history-search :deep(.el-input__inner:focus) {
  border-color: #7c3aed;
}

.learning-history-list {
  flex: 1;
  min-height: 0;
  margin-top: 14px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.learning-history-group + .learning-history-group {
  margin-top: 16px;
}

.learning-history-group h4 {
  margin: 0 0 8px;
  color: #302742;
  font-size: 13px;
  font-weight: 800;
}

.learning-history-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 62px;
  margin-bottom: 7px;
  padding: 11px 12px;
  border: 1px solid #e4dfeb;
  border-radius: 10px;
  color: #302742;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.learning-history-item:hover:not(:disabled),
.learning-history-item:focus-visible {
  border-color: #a78bfa;
  background: #faf8ff;
  transform: translateY(-1px);
}

.learning-history-item--active {
  border-color: #c4b5fd;
  background: #f5f3ff;
}

.learning-history-item--active::before {
  content: "";
  position: absolute;
  top: 9px;
  bottom: 9px;
  left: 0;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #7c3aed;
}

.learning-history-item:disabled {
  cursor: wait;
  opacity: 0.68;
}

.learning-history-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 4px;
}

.learning-history-copy strong,
.learning-history-copy small {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.learning-history-copy strong {
  color: inherit;
  font-size: 13px;
  line-height: 1.3;
}

.learning-history-copy small {
  color: #7b718d;
  font-size: 11px;
  line-height: 1.3;
}

.learning-history-time {
  flex-shrink: 0;
  color: #7b718d;
  font-size: 11px;
  line-height: 1.3;
}

.learning-history-state {
  display: flex;
  min-height: 150px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  box-sizing: border-box;
  color: #776b8e;
  font-size: 13px;
  text-align: center;
}

.learning-history-state--error {
  flex-direction: column;
  color: #a03b48;
}

.learning-history-state button {
  padding: 7px 12px;
  border: 1px solid #c4b5fd;
  border-radius: 8px;
  color: #5b21b6;
  background: #f5f3ff;
  cursor: pointer;
}

.learning-history-new {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  margin-top: 14px;
  border: 0;
  border-radius: 10px;
  color: #fff;
  background: #6d28d9;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(109, 40, 217, 0.22);
}

.learning-history-new:hover,
.learning-history-new:focus-visible {
  background: #5b21b6;
}

.learning-history-enter-active .learning-history-drawer,
.learning-history-leave-active .learning-history-drawer,
.learning-history-enter-active .learning-history-scrim,
.learning-history-leave-active .learning-history-scrim {
  transition: transform 0.24s ease, opacity 0.24s ease;
}

.learning-history-enter .learning-history-drawer,
.learning-history-leave-to .learning-history-drawer {
  transform: translateX(100%);
}

.learning-history-enter .learning-history-scrim,
.learning-history-leave-to .learning-history-scrim {
  opacity: 0;
}

@media (max-width: 760px) {
  .learning-history-drawer {
    width: 100%;
    min-width: 0;
    max-width: none;
    border-radius: 0;
  }
}

.chat-list {
  width: 100%;
  height: 100%;
  background-color: #f9fbff;
  .title {
    height: 60px;
    color: #409eff;
    font-size: 25px;
    display: flex;
    font-weight: 700;
    align-items: center;
    font-family: "Orbitron", "Rajdhani", sans-serif;
    letter-spacing: 2px;
    font-style: italic;
    text-transform: uppercase;
    justify-content: center;
  }
  .input{
    margin: 30px 0 0 0;
    padding: 0 12px;
  }
  :deep(.el-input__inner){
    border-radius: 14px;
    background: rgb(219 234 254);
    border: 0;
  }
  :deep(.el-input__prefix){
    left: 14px;
  }
  :deep(.el-input__inner::placeholder){
  }
  .chat-p-list {
    height: calc(100% - 210px);
    overflow-y: auto;
    .data{
      color: #555;
      margin: 30px 0 6px -6px;
      padding: 0 12px;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      position: sticky;
      top: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      img{
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }
    }
  }
  .chat-item {
    height: 38px;
    color: rgb(38 38 38);
    background-color: #f9fbff;
    cursor: pointer;
    border-radius: 14px;
    align-items: center;
    padding: 0 12px;
    font-size: 14px;
    display: flex;
    position: relative;
    &:hover {
      background-color: rgb(239 246 255);
    }
    span {
      white-space: nowrap;
      flex: 1;
      align-items: center;
      min-width: 0;
      line-height: 18px;
      display: flex;
      overflow: hidden;
      color: rgb(38 38 38);
      cursor: pointer;
      width: 100%;
      text-overflow: ellipsis;
      font-family: 'Ubuntu', sans-serif;
    }
  }
  .user-info {
    padding: 12px;
    height: 56px;
    line-height: 32px;
    margin: 12px;
    border-radius: 8px;
    .avatar {
      background: #409eff;
      margin-right: 12px;
      color: #fff;
    }
    &:hover {
      background-color: rgb(239 246 255);
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #606266;
  }
}
.chat-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  align-items: center;
  padding: 24px 10px 12px;
  max-width: 1000px;
  &.chat-hide{
    height: 100%;
    width: 100%;
    max-width: unset;
    padding: 24px 16px 0;
    border-radius: 0 0 24px 24px;
  }
}

.topic-header {
  padding: 10px 0;
  background: #fff;
  width: 1000px;
  max-width: 1000px;
}

.topic-header h2 {
  margin: 0;
  color: #333;
  font-size: 16px;
  text-align: center;
}

.chat-content {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
  width: 100%;
  max-width: 1000px;
  border-radius: 8px;
}

.message {
  display: flex;
  margin-bottom: 15px;
  gap: 8px;
}

.message.bot {
  margin-right: 20px;
}

.message.user {
  flex-direction: row-reverse;
  margin-left: 20px;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.avatar img {
  width: 24px;
  height: 24px;
}

.avatar-name {
  font-size: 18px;
  font-weight: 600;
}

.message-content {
  background: #fff;
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 80%;
}
.copy{
  padding: 20px 8px;
  position: relative;
}
:deep(.el-icon-copy-document){
  position: absolute;
  right: 6px;
  top: 6px;
  font-size: 14px;
  cursor: pointer;
}

.message.user .message-content {
  background: #ecf5ff;
}

.message-content :deep(h3) {
  margin: 10px 0 8px;
  color: #333;
  font-size: 18px;
}

.message-content :deep(h3:first-child) {
  margin-top: 0;
}

.message-content :deep(p) {
  color: #666;
  line-height: 1.4;
  font-size: 18px;
}

.message-content :deep(ol) {
  margin: 0;
  padding-left: 18px;
}

.message-content :deep(li) {
  margin-bottom: 8px;
  color: #666;
  font-size: 18px;
}

.message-content :deep(pre) {
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 18px;
}

.message-content :deep(code) {
  font-family: monospace;
}

.message-content :deep(.katex) {
  font-size: 18px;
}

.message-content :deep(.katex-display) {
  margin: 0.8em 0;
  overflow-x: auto;
  overflow-y: hidden;
}
.section {
  width: 100%;
  max-width: 1000px;
  background: #fff;
  display: flex;
  margin: 24px 0;
  box-shadow: 0px 0px 0px 1px #dcdfe6;
  flex-direction: column;
  border-radius: 24px;
  position: relative;
  img {
    width: 50px;
    height: 50px;
    border: 1px dashed rgb(96, 98, 102);
    border-radius: 9px;
    margin: 12px;
  }
  .close {
    position: absolute;
    font-size: 16px;
    color: rgb(96, 98, 102);
    top: 5px;
    left: 54px;
    cursor: pointer;
  }
}

.chat-quota-row {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 14px 8px;
  color: #6427c7;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

.chat-quota-remaining {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.chat-quota-row small {
  color: #8b849c;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.chat-quota-row--empty,
.chat-quota-row--empty small {
  color: #d13c5a;
}
.input-section {
  width: 100%;
  background: rgb(243 244 246);
  display: flex;
  position: relative;
  flex-direction: column;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0px 0px 0px 0.5px #dcdfe6;

  .send-button {
    display: flex;
    height: 32px;
    align-items: center;
    justify-content: flex-end;
    .send-message {
      width: 32px;
      padding: 0;
      border-radius: 8px;
      height: 100%;
      margin-left: 12px;
      position: relative;
      &:before{
        content: "";
        position: absolute;
        width: 1px;
        height: 100%;
        background: #bbbfc9;
        left: -10px;
        top: 0;
      }
    }
  }
}

.input-section .el-textarea {
  flex: 1;
}

.input-section .el-textarea >>> .el-textarea__inner {
  height: 50px !important;
  border-radius: 4px 0 0 4px;
  resize: none;
  padding: 0;
  font-size: 18px;
  border: 0;
  background: rgb(243 244 246);
}

.input-section .el-textarea >>> .el-textarea__inner::placeholder {
  font-size: 18px;
}

.input-section .el-button {
  height: auto;
  padding: 0 20px;
}

.input-section .el-button i {
  font-size: 20px;
}
:deep(.el-form-item) {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}
:deep(.el-form-item__label) {
  width: auto;
  min-width: 80px;
  max-width: 40vw;
  word-break: break-all;
  white-space: normal;
  box-sizing: border-box;
  text-align: left;
  line-height: 21px;
  font-weight: 500;
  margin-bottom: 4px;
  font-size: 14px;
  color: #1f2328;
}
:deep(.el-form-item__content) {
  margin: 0 !important;
}
:deep(.el-form-item__error) {
  margin-bottom: 4px;
}
:deep(.el-input__inner) {
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
}
:deep(.el-dialog__body) {
  border: 1px solid #dcdfe6;
  border-left: 0;
  border-right: 0;
  padding: 10px 20px 0;
}
:deep(.el-dialog__footer) {
  padding: 20px 20px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .chat-container {
    height: calc(100vh - 60px);
    padding: 0 5px;
  }

  .topic-header {
    padding: 5px 0;
  }

  .topic-header h2 {
    font-size: 14px;
  }

  .chat-content {
    padding: 5px;
    border-radius: 6px;
  }

  .message {
    margin-bottom: 10px;
    gap: 6px;
  }

  .message.bot {
    margin-right: 10px;
  }

  .message.user {
    margin-left: 10px;
  }

  .avatar {
    width: 28px;
    height: 28px;
    font-size: 16px;
  }

  .avatar img {
    width: 20px;
    height: 20px;
  }

  .message-content {
    padding: 3px 6px;
    border-radius: 6px;
  }

  .message-content :deep(h3) {
    margin: 8px 0 6px;
    font-size: 18px;
  }

  .message-content :deep(p) {
    font-size: 18px;
    line-height: 1.3;
  }

  .message-content :deep(li) {
    font-size: 18px;
    margin-bottom: 6px;
  }

  .message-content :deep(pre) {
    padding: 8px;
    font-size: 18px;
  }

  .input-section {
    padding: 5px 0;
    gap: 5px;
  }

  .input-section .el-textarea >>> .el-textarea__inner {
    height: 40px !important;
    padding: 8px 6px;
    font-size: 13px;
  }

  .input-section .el-textarea >>> .el-textarea__inner::placeholder {
    font-size: 13px;
  }

  .input-section .el-button {
    padding: 0 15px;
  }

  .input-section .el-button i {
    font-size: 18px;
  }
}
</style>
<style lang="scss">
.el-dropdown-menu {
  border-radius: 8px !important;
  padding: 12px !important;
  .el-dropdown-menu__item {
    border-radius: 8px !important;
    font-weight: bold;
    display: flex;
    align-items: center;
    img{
      width: 20px;
      height: 20px;
      color: #606266;
      margin-right: 6px;
    }
    &:hover {
      background: #f5f7fa !important;
      color: #606266 !important;
    }
  }
  .popper__arrow {
    display: none !important;
  }
}
.el-dialog{
  border-radius: 24px !important;
}
</style>
